import { MoneyBox } from '@apply/components';
import { formatCurrencyOrUndefined } from '@apply/ui';
import { IBudgetFixFlip } from '@apply/api/src/api/ApplyApi';
import { ApplicationQuestionReviewItem } from '../../../../components/ApplicationQuestionReviewItem';
import { useBudgetFixFlipField } from '../../../../../queries/useBudgetFixFlipField';

interface Item4Props {
    required?: boolean;
    propertyGuid: string;
    isReview?: boolean;
}

export const Item4: React.FC<Item4Props> = ({ required = false, propertyGuid, isReview = false }) => {
    const [item4, set_item4] = useBudgetFixFlipField<number>(
        propertyGuid,
        (b) => (b.values?.['Expand Primary Structure']?.['Item #4']?.[1] as number) ?? 0,
        (b, v) => ({ ...b, values: { ...b.values, 'Expand Primary Structure': { ...b.values?.['Expand Primary Structure'], 'Item #4': [b.values?.['Expand Primary Structure']?.['Item #4']?.[0] ?? '', v] as [string, number] } } })
    );
    const label = 'Item #4';
    return (
        <>
            {isReview ? (
                <ApplicationQuestionReviewItem
                    label={label}
                    value={formatCurrencyOrUndefined(item4)}
                />
            ) : (
                <MoneyBox
                    id={'item4'}
                    allowNegative={false}
                    value={item4}
                    onChange={(value) => set_item4(value)}
                    required={required}
                    label={label}
                />
            )}
        </>
    );
};
